<template>
  <div class="text-center mt-4">
    <h3>
      Your download will start in a moment...
    </h3>
    <h5 class="mt-4">
      If your download doesn't start, please click on the button below
    </h5>

    <span class="btn btn-success cursor-pointer" @click="download()">
      Download
    </span>

  </div>
</template>

<script>

  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'Downloads',
    data() {
      return {

      };
    },
    components: {

    },
    methods: {
      download() {
        let self = this;
        // Component accessed when going on route: base_url/downloads/{media}
        if (this.$route.params.media) {
          piincHttp.get('documents/' + this.$route.params.media + '/download', {responseType: 'blob'}).then(function(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', self.$route.params.media);

            link.click();
            link.remove()
            window.URL.revokeObjectURL(url);
          }, function() {});
        }
      }
    },
    created() {
      this.download()
    }
  }

</script>
